import { collection, query, orderBy, getDocs, updateDoc, doc, arrayUnion, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const getOrganizations = async () => {
  const querySnapshot = await getDocs(query(collection(db, 'organizations'), orderBy('name', 'desc')));

  const organizations = [];
  querySnapshot.forEach((doc) => {
    organizations.push(doc.data());
  });

  return organizations;
};

export const setTeams = async (club, team) => {
  await updateDoc(doc(db, 'organizations', club), {
    teams: arrayUnion({ name: team }),
  });
};

export const setClubAndTeam = async (club, team) => {
  await setDoc(doc(db, 'organizations', club), {
    name: club,
    teams: [{ name: team }],
  });
};
